@if (isAnimating || !hideOnComplete) {
  <mat-progress-bar
    mode="determinate"
    @fadeOut
    [value]="progress"
  ></mat-progress-bar>
}
